export default __webpack_public_path__ + "static/media/icon-doctor-availability-sider.e0059aac.svg";